import * as React from 'react';

function IconEnvelopeSolid(props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>): React.JSX.Element {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className="inline-flex h-[1.715em] w-[1.715em] flex-shrink-0"
            data-taco="icon"
            data-icon-name="phone-solid"
            focusable="false"
            role="img"
            ref={svgRef}
            {...props}>
            <path
                d="M2.13703 5.06999L10.9066 12.0856C11.5457 12.5969 12.4539 12.5969 13.093 12.0856L21.8629 5.06972C21.9512 5.27884 22 5.50872 22 5.75V18.25C22 19.2165 21.2165 20 20.25 20H3.75C2.7835 20 2 19.2165 2 18.25V5.75C2 5.50882 2.04879 5.27904 2.13703 5.06999ZM3.28038 4.06373C3.42982 4.0222 3.58732 4 3.75 4H20.25C20.4126 4 20.5699 4.02216 20.7193 4.06364L12.1559 10.9143C12.0646 10.9873 11.9349 10.9874 11.8436 10.9143L3.28038 4.06373Z"
                fill="currentColor"
                fillRule="evenodd"
            />
        </svg>
    );
}
export default React.forwardRef(IconEnvelopeSolid);
